import { DEAL_CONFIGURATION_QUERY, DEAL_OWNERS_QUERY } from "@/graphql/queries/deal";
import { decodeId, IdToNode, capitalize } from "@/lib/string";
import {
  CREATE_DEAL_CALL_MUTATION,
  DELETE_DEAL_CALL_MUTATION,
  UPDATE_DEAL_CALL_MUTATION,
  UPDATE_DEAL_CONTACT_MUTATION,
  UPDATE_DEAL_MUTATION,
} from "@/graphql/mutations/deal";

export default {
  data() {
    return {
      dealOwners: [],
      dealConfiguration: {
        stages: [],
      },
      logCallDialog: false,
      options: {
        callOutcomes: [
          { text: "Answered", value: "ANSWERED" },
          { text: "Not Answered", value: "NOT_ANSWERED" },
        ],
        probabilities: [
          { text: "Not Set", value: "NOT_SET" },
          { text: "Zero", value: "ZERO" },
          { text: "Low", value: "LOW" },
          { text: "Medium", value: "MEDIUM" },
          { text: "High", value: "HIGH" },
        ],
      },
    };
  },
  computed: {
    stages() {
      return this.dealConfiguration.stages.map((element) => {
        return {
          text: capitalize(element.title),
          value: element.id,
        };
      });
    },
  },
  methods: {
    showSuccessMessage(message) {
      this.$toasted.success(message, {
        duration: 2000,
        position: "bottom-center",
      });
    },
    async updateDeal(data) {
      const result = await this.$apollo.mutate({
        mutation: UPDATE_DEAL_MUTATION,
        variables: {
          data: data,
        },
      });
      return result;
    },
    async setDealOwner(ownerId, id) {
      const dealId = decodeId(id);
      const result = await this.updateDeal({
        dealId: dealId,
        dealOwnerId: ownerId,
      });
      if (result.data.upsertDealMutation.success) this.showSuccessMessage("Deal Owner updated");
    },
    async setStage(stage, id) {
      const dealId = decodeId(id);
      const result = await this.updateDeal({
        dealId: dealId,
        stageId: stage,
      });
      if (result.data.upsertDealMutation.success) this.showSuccessMessage("Stage updated");
    },
    async setProbability(probability, id) {
      let dealId = decodeId(id);
      const result = await this.updateDeal({
        dealId: dealId,
        probability: probability,
      });
      if (result.data.upsertDealMutation.success) this.showSuccessMessage("Probability updated");
    },
    async setNote(note, id) {
      let dealId = decodeId(id);
      const result = await this.updateDeal({
        dealId: dealId,
        note: note,
      });
      if (result.data.upsertDealMutation.success) this.showSuccessMessage("Note updated");
    },
    async insertLoggedCall(data) {
      delete data["callId"];
      const result = await this.$apollo.mutate({
        mutation: CREATE_DEAL_CALL_MUTATION,
        variables: {
          data: data,
        },
      });
      if (result.data.createDealCallMutation.success) this.showSuccessMessage("Call logged");
      this.logCallDialog = false;
    },
    async editLoggedCall(data) {
      delete data["dealId"];
      const result = await this.$apollo.mutate({
        mutation: UPDATE_DEAL_CALL_MUTATION,
        variables: {
          data: data,
        },
      });
      if (result.data.updateDealCallMutation.success) this.showSuccessMessage("Call Updated");
      this.logCallDialog = false;
    },
    async updateDealContact(data) {
      const result = await this.$apollo.mutate({
        mutation: UPDATE_DEAL_CONTACT_MUTATION,
        variables: {
          data: data,
        },
      });
      if (result.data.updateDealContactMutation.success) this.showSuccessMessage("Contact Updated");
    },
    async deleteCall(call) {
      const proceed = window.confirm("Are you sure you want to delete this call?");
      if (!proceed) return false;

      await this.$apollo.mutate({
        mutation: DELETE_DEAL_CALL_MUTATION,
        variables: {
          callId: call.id,
        },
      });
      return true;
    },
  },
  apollo: {
    dealConfiguration: {
      query: DEAL_CONFIGURATION_QUERY,
      fetchPolicy: "cache-and-network",
    },
    dealOwners: {
      query: DEAL_OWNERS_QUERY,
      fetchPolicy: "cache-and-network",
      update(data) {
        return data.dealOwners.map((obj) => ({ ...obj, nodeID: IdToNode(obj.user.id) }));
      },
      result(response) {
        if (response.data) {
          const dealOwner = response.data.dealOwners.find(
            (element) => element.user.id == decodeId(this.$store.getters.user.id)
          );
          if (dealOwner) {
            if (this.filters) {
              this.filters.dealOwner_User_Id_In = [decodeId(this.$store.getters.user.id)];
            }
          }
        }
      },
    },
  },
};
